var Block_Chiffres = {

    array_swiper:[],

    init:function(){
        $(window).resize(function(){
            Block_Chiffres.resize();
        });
        Block_Chiffres.resize();
    },
    resize:function(){
        $(".block-chiffres").each(function(){
            var _slides_to_show = 0;
            var _id = $(this).attr("id");
            var el = document.getElementById(_id);
            _slides_to_show = parseInt( window.getComputedStyle(el).getPropertyValue("--nbslide"));

            if(_slides_to_show != 0){
                Block_Chiffres.createSwiper(_id, _slides_to_show);
            }else{
                Block_Chiffres.destroySwiper(_id);
            }
        })
    },
    createSwiper:function(pID, _slides_to_show){

        if(!$("#" + pID + " .slider-container").hasClass("swiper-initialized")){
            var swiper = new Swiper(
                "#" + pID + " .slider-container",
                {
                    speed: 600,
                    loop: false,
                    slidesPerView: "auto",
                    centeredSlides: false,
                    freeMode: false,
                    grabCursor: true,
                    mousewheel: false,
                    slideToClickedSlide: false,
                    touchStartPreventDefault: false,
                    preventClicks: true,
                    spaceBetween:60,
                }
            );

            Block_Chiffres.array_swiper.push({id:pID, swiper:swiper, nb_slides:_slides_to_show});
        }
    },
    destroySwiper:function(pID){
        if($("#" + pID + " .slider-container").hasClass("swiper-initialized")){
            for (var i = 0; i < Block_Chiffres.array_swiper.length; i++){
                if(Block_Chiffres.array_swiper[i].id == pID){
                    Block_Chiffres.array_swiper[i].swiper.destroy();
                    Block_Chiffres.array_swiper.splice(i, 1);
                }
            }
        }

    }
}

$(window).load(function(){
    if($(".block-chiffres").length){
        Block_Chiffres.init();
    }
})